import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: '',
};

export const counterSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    getLocale: (state, action) => {

      state.value = action.payload;
    },
    setLocale: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { getLocale, setLocale } = counterSlice.actions;

export default counterSlice.reducer;
